export const getPercentage = (value: number = 0) => {
  return value.toFixed(2);
}